import * as React from "react";
import { Component } from "react";
import { Button, FormControl, FormGroup, Glyphicon, Table } from "react-bootstrap";
import { IAdvancedStatementsTableProps, IAdvancedStatementsTableState } from "./interfaces";

export default class AdvancedStatementsTable extends Component<
  IAdvancedStatementsTableProps,
  IAdvancedStatementsTableState
> {
  public constructor(props: IAdvancedStatementsTableProps) {
    super(props);
  }

  public render() {
    const { appService } = this.props;
    const location = appService.getActiveProjectLocation();

    return (
      <div className="flex" style={{ marginTop: "6px" }}>
        <div className="row">
          <Table id="advancedDualRateTable" bordered={false} striped={true}>
            <colgroup>
              <col width="90" />
              <col width="90" />
              <col width="90" />
              <col width="80" />
              <col width="80" />
              {!this.props.isSimpleStatement ? <col width="80" /> : null}
              <col width="80" />
              {!this.props.isSimpleStatement ? <col width="80" /> : null}
              <col width="50" />
              {!this.props.isSimpleStatement ? <col width="50" /> : null}
              <col width="25" />
            </colgroup>
            <thead>
              <tr>
                {!this.props.isSimpleStatement ? (
                  <th colSpan={12}>
                    <h3>{location} Statements</h3>
                  </th>
                ) : (
                  <th colSpan={9}>
                    <h3>{location} Statements</h3>
                  </th>
                )}
              </tr>
              <tr>
                <th className="advancedDualRateTable advancedDualRateTable-header">
                  Statement Date
                </th>
                <th className="advancedDualRateTable-header">Service Start</th>
                <th className="advancedDualRateTable-header">Service End</th>
                <th className="advancedDualRateTable-header">Years with Solar</th>
                <th className="advancedDualRateTable-header">Grid Reading</th>
                {!this.props.isSimpleStatement ? (
                  <th className="advancedDualRateTable-header">On-peak Grid Reading</th>
                ) : null}
                <th className="advancedDualRateTable-header">Solar Reading</th>
                {!this.props.isSimpleStatement ? (
                  <th className="advancedDualRateTable-header">On-peak Solar Reading</th>
                ) : null}
                <th className="advancedDualRateTable-header">Solar Generated</th>
                {!this.props.isSimpleStatement ? (
                  <th className="advancedDualRateTable-header">On-peak Credits</th>
                ) : (
                  <th className="advancedDualRateTable-header">Credit Balance</th>
                )}
                {!this.props.isSimpleStatement ? (
                  <th className="advancedDualRateTable-header">Off-peak Credits</th>
                ) : null}
                <th />
              </tr>
            </thead>
            <tbody>
              {this.props.statements.map((statement, index, statements) => (
                <tr key={statement.id}>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-date">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="statementDate">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="date"
                          value={new Date(statement.statementDate).toISOString().substring(0, 10)}
                          onChange={this.props.statementDateChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{new Date(statement.statementDate).toISOString().substring(0, 10)}</div>
                    )}
                  </td>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-date">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="serviceStartDate">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="date"
                          value={new Date(statement.serviceStartDate)
                            .toISOString()
                            .substring(0, 10)}
                          onChange={this.props.serviceStartDateChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>
                        {new Date(statement.serviceStartDate).toISOString().substring(0, 10)}
                      </div>
                    )}
                  </td>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-date">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="serviceEndDate">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="date"
                          value={new Date(statement.serviceEndDate).toISOString().substring(0, 10)}
                          onChange={this.props.serviceEndDateChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{new Date(statement.serviceEndDate).toISOString().substring(0, 10)}</div>
                    )}
                  </td>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-int">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="yearsWithSolar">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="number"
                          value={statement.yearsWithSolar}
                          onChange={this.props.yearsWithSolarChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{statement.yearsWithSolar}</div>
                    )}
                  </td>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="gridReading">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="number"
                          value={statement.gridReading}
                          onChange={this.props.gridReadingChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{statement.gridReading}</div>
                    )}
                  </td>
                  {!this.props.isSimpleStatement ? (
                    <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                      {statement.isEditing ? (
                        <FormGroup bsSize="small" controlId="onPeakGridReading">
                          <FormControl
                            className="statemenTableEditor"
                            bsSize="small"
                            type="number"
                            value={statement.onPeakGridReading}
                            onChange={this.props.onPeakGridReadingChanged}
                          />
                        </FormGroup>
                      ) : (
                        <div>{statement.onPeakGridReading}</div>
                      )}
                    </td>
                  ) : null}
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="solarReading">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="number"
                          value={statement.solarReading}
                          onChange={this.props.solarReadingChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{statement.solarReading}</div>
                    )}
                  </td>
                  {!this.props.isSimpleStatement ? (
                    <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                      {statement.isEditing ? (
                        <FormGroup bsSize="small" controlId="onPeakSolarReading">
                          <FormControl
                            className="statemenTableEditor"
                            bsSize="small"
                            type="number"
                            value={statement.onPeakSolarReading}
                            onChange={this.props.onPeakSolarReadingChanged}
                          />
                        </FormGroup>
                      ) : (
                        <div>{statement.onPeakSolarReading}</div>
                      )}
                    </td>
                  ) : null}
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="solarGenerated">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="number"
                          value={statement.solarGenerated}
                          onChange={this.props.solarGeneratedChanged}
                          autoFocus={true}
                        />
                      </FormGroup>
                    ) : (
                      <div>{statement.solarGenerated}</div>
                    )}
                  </td>
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                    {statement.isEditing ? (
                      <FormGroup bsSize="small" controlId="onPeakCredits">
                        <FormControl
                          className="statemenTableEditor"
                          bsSize="small"
                          type="number"
                          value={statement.onPeakCredits}
                          onChange={this.props.onPeakCreditsChanged}
                        />
                      </FormGroup>
                    ) : (
                      <div>{statement.onPeakCredits}</div>
                    )}
                  </td>
                  {!this.props.isSimpleStatement ? (
                    <td className="advancedDualRateTable-cell advancedDualRateTable-cell-kwh">
                      {statement.isEditing ? (
                        <FormGroup bsSize="small" controlId="offPeakCredits">
                          <FormControl
                            className="statemenTableEditor"
                            bsSize="small"
                            type="number"
                            value={statement.offPeakCredits}
                            onChange={this.props.offPeakCreditsChanged}
                          />
                        </FormGroup>
                      ) : (
                        <div>{statement.offPeakCredits}</div>
                      )}
                    </td>
                  ) : null}
                  <td className="advancedDualRateTable-cell advancedDualRateTable-cell-actions">
                    {statement.isEditing ? (
                      <div>
                        <Button
                          bsSize="xsmall"
                          bsStyle="warning"
                          className="button-all"
                          // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.props.saveStatement(statement, index, statements)}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-ok" />
                        </Button>
                        <Button
                          bsSize="xsmall"
                          bsStyle="danger"
                          className="button-all"
                          onClick={this.props.cancelChanges}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-remove" />
                        </Button>
                        <Button
                          bsSize="xsmall"
                          bsStyle="primary"
                          className="button-all"
                          onClick={this.props.saveAndNext}
                          disabled={index === statements.length - 1}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-circle-arrow-down" />
                        </Button>
                        <Button
                          bsSize="xsmall"
                          bsStyle="success"
                          className="button-all"
                          onClick={this.props.saveAndPrior}
                          disabled={index === 0}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-circle-arrow-up" />
                        </Button>
                      </div>
                    ) : (
                      <Button
                        bsSize="xsmall"
                        bsStyle="primary"
                        className="button-all"
                        disabled={this.props.activeIndex > -1}
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => this.props.editStatement(statement, index, statements)}
                      >
                        <Glyphicon glyph="glyphicon glyphicon-edit" />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/AdvancedStatementsTable.tsx